// removed by extract-text-webpack-plugin
module.exports = {"checkbox-input":"Checkbox__checkbox-input","checkboxInput":"Checkbox__checkbox-input","checkmark":"Checkbox__checkmark","att-icon-lg":"Checkbox__att-icon-lg","attIconLg":"Checkbox__att-icon-lg","checkbox":"Checkbox__checkbox","disabled":"Checkbox__disabled","checkbox-renny":"Checkbox__checkbox-renny","checkboxRenny":"Checkbox__checkbox-renny","checkbox-input-renny":"Checkbox__checkbox-input-renny","checkboxInputRenny":"Checkbox__checkbox-input-renny"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Checkbox/Checkbox.css
// module id = 1119
// module chunks = 8